import { Container, Row, Col } from "react-bootstrap";
import React from "react";
import Link from "next/link";
import { parseHtml } from "../../../utils/common";
import dynamic from "next/dynamic";

const HocButton = dynamic(() => import('../../HigherOrderComponent/HocButton'))

function OptToHire(props) {
	let block = props.block;

	return (
		<>
			<section className="onestop-section">
				<div className="onestop-inner">
					<Container>
						<Row>
							<Col lg={12}>
								<div className="heading">
									<h3>{block.short_title}</h3>
									<h2>{block.title}</h2>
								</div>
							</Col>
						</Row>
						<Row>
							{block?.statistics?.map((ele, index) => {
								return (
									<Col
										lg={4}
										md={6}
										key={index}
										className="box-card"
									>
										<div
											className={`onestop-box ${
												(index + 1) % 2 === 0
													? "box-green"
													: null
											}`}
										>
											<div className="box-inner">
												<div className="box-counter">
													<h3>{ele.numbers}</h3>
												</div>
												<div className="box-content">
													<h3>{ele.title}</h3>
													{ele.description
														? parseHtml(
																ele.description, true
															)
														: ""}
												</div>
											</div>
										</div>
									</Col>
								);
							})}
						</Row>
						<Row>
							<Col lg={12} md={12} className="d-flex justify-content-center">
								{block?.button?.label && (
									<HocButton
										button={block?.button}
										btnAction={() => {
											window.scrollTo({
												top: 0,
												behavior: 'smooth',
											})
										}}
									>
										<Link
											href={
												block?.button?.href ? block?.button?.href : '#'
											}
											className="btn btn-primary"
										>
											{block?.button?.label}
										</Link>
									</HocButton>
								)}
							</Col>
						</Row>
					</Container>
				</div>
			</section>
		</>
	);
}

export default OptToHire;

